import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import AccountCreation, {
    Input,
    Social
} from "@/components/signup/account-creation";
import { SocialProvider } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";
import { useWacRefresh } from "@/utils/wac-refresh/wac-refresh-context";

import { InlineInputSubmitSocial } from "./components/inline-account-creation";

export type SignUpFormTextColor = "default" | "light";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
    helpText?: string;
    textColor?: SignUpFormTextColor;
    inline?: boolean;
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const UniformSignUpForm = ({
    socialProviders,
    helpText,
    textColor = "default",
    inline = false
}: UniformSignUpProps) => {
    const intl = useIntl();
    const isWacRefresh = useWacRefresh();

    const defaultHelpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperTextTeam26",
        defaultMessage:
            "Use a work email to find teammates and get access to Rovo AI"
    });
    const configuredHelpText = helpText?.trim();
    const emailHelpText = configuredHelpText || defaultHelpText;

    return (
        <div css={[textColor === "light" && lightTextColorCss]}>
            <AccountCreation
                Login={null}
                Separator={inline ? null : undefined}
                Error={inline ? null : undefined}
                Input={
                    inline ? (
                        <InlineInputSubmitSocial
                            helpText={configuredHelpText}
                        />
                    ) : isWacRefresh ? (
                        <Input helpText={emailHelpText} />
                    ) : undefined
                }
                Submit={inline ? null : undefined}
                Social={
                    inline ? null : socialProviders?.length ? (
                        <Social
                            providers={transformProviders(socialProviders)}
                        />
                    ) : undefined
                }
            />
        </div>
    );
};

export default UniformSignUpForm;

const lightTextColorCss = css({
    color: wacToken("color.neutral.light0")
});
